import Loadmore from "../loadmore/Loadmore";
class LoadMoreCategory {
    constructor(data) {
        this.data = data;
    }
    start() {
        var _a;
        //chỉ khởi tạo loadmore
        const loadmore = new Loadmore(this.data);
        //sau đó mới lắng nghe sự kiện click | set states ++paged
        (_a = this.data.btnLoadmore) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
            loadmore.load();
        });
    }
}
export default LoadMoreCategory;
